import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { store } from "react-notifications-component";

interface IProps {
  successText: string | null;
  onHide: Function;
}

const SuccessAlerts: React.FC<IProps> = ({ successText, onHide }: IProps) => {
  const { t } = useTranslation();
  useEffect(() => {
    const successNotifications = () => {
      store.addNotification({
        title: t("sukces"),
        type: "success",
        message: Boolean(successText) ? successText : "",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
          showIcon: true,
        },
        onRemoval: () => {
          onHide();
        },
      });
    };

    if (successText) {
      successNotifications();
    }
    //eslint-disable-next-line
  }, [successText]);
  return <React.Fragment></React.Fragment>;
};

export default SuccessAlerts;
